import { OpenFeature } from '@openfeature/react-sdk';

import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';

/**
 * Killswitch for the table round-trip fixes in the vMarkdown serializers:
 * headerless pipe-table parsing in `simpleMarkdownToHtml`, and cell
 * line-break preservation, pipe escaping, and list-tag encode/restore.
 * OFF (default): the fixes are active. ON: break-glass — both sides revert
 * to the legacy behavior (separator-less pipe rows render as paragraphs;
 * cell content flattens and list tags stay escaped). The `\|` unescape in
 * `parseTableRow` stays active so cells saved with escaped pipes remain readable.
 * Called outside React (markdown helpers), so non-hook only.
 *
 * Lives in this standalone `.ts` module (not the `index.tsx` barrel) so the
 * reader does not add a `react-refresh/only-export-components` warning to the
 * component barrel. Import it directly from
 * `@/features/flags/table-roundtrip-flag`.
 */
export const isTableRoundTripFixKilled = () => {
  return OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'op-scribe-disable-table-roundtrip-fix',
    false
  );
};
